import React from 'react';
import { Icon, Tooltip } from '@upsales/components';
import T from 'Components/Helpers/translate';
import ContactResource from 'App/resources/Contact';
import type Contact from 'App/resources/Model/Contact';
import logError from 'Helpers/logError';

type ContactPriorityIconProps = {
	contact: Contact;
	onUpdate?: (updatedContact: Contact) => void;
	className?: string;
};

const ContactPriorityIcon: React.FC<ContactPriorityIconProps> = ({ contact, onUpdate, className }) => {
	const togglePriority = async (e: React.MouseEvent) => {
		e.stopPropagation();
		const newPriority = !contact.isPriority;
		try {
			await ContactResource.save({ id: contact.id, isPriority: newPriority });
			if (onUpdate) {
				onUpdate({ ...contact, isPriority: newPriority });
			}
		} catch (error) {
			logError(error, 'Failed to update contact priority');
		}
	};

	const disabled = !contact.userEditable;
	let tooltip = T('contact.addPriority');
	if (disabled) {
		tooltip = T('noEditRights.contact');
	} else if (contact.isPriority) {
		tooltip = T('contact.removePriority');
	}

	return (
		<Tooltip title={tooltip}>
			<Icon
				name={contact.isPriority ? 'star' : 'star-o'}
				onClick={togglePriority}
				className={className}
				style={disabled ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}
			/>
		</Tooltip>
	);
};

export default ContactPriorityIcon;
